import { validateBankAccount } from "./bankService";

export const validateBankAccountAction = (payload) => async () => {
  const response = await validateBankAccount(payload);
  return response;
};